import React from 'react';
import { Grid, Typography, Input, Checkbox } from '@ntuctech/devex-tangram';
import styled from 'styled-components';
import { Container } from './BusinessQuanity';

const StyledTypography = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0;
  margin-left: 0.25rem;
`;

const StyledAcknowledge = styled.div`
  display: flex;
`;

const DeliveryInformation = ({ setVoucherData, voucherData, isEditMode, isCheck, setIsCheck }) => {
  const [isError, setIsError] = React.useState(false);
  const [isErrorEmail, setIsErrorEmail] = React.useState(false);
  const [isSameEmail, setIsSameEmail] = React.useState(false);
  /* eslint-disable no-useless-escape */
  const emailFormat =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      voucherData.businessEmail
    );
  /* eslint-disable no-useless-escape */
  const otherEmailFormat =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      voucherData.otherBusinessEmail
    );

  const getHelperTextEmail = () => {
    if (voucherData.businessEmail) {
      return !emailFormat
        ? 'Enter a valid email address.'
        : 'This recipient is the main person to receive all vouchers for distribution.';
    }
    return 'This recipient is the main person to receive all vouchers for distribution.';
  };

  /* eslint-disable no-unused-expressions */
  const handleOnBlur = (name, value) => {
    if (name === 'email') {
      value !== '' ? setIsError(!emailFormat) : setIsError(false);
    }
    if (name === 'resend-email') {
      value !== '' ? setIsErrorEmail(!otherEmailFormat) : setIsErrorEmail(false);
    }
  };

  const helpOtherEmailText = () => {
    if (isSameEmail) {
      return 'Enter a different email address here.';
    }
    if (isErrorEmail) {
      return 'Enter a valid email address.';
    }
    return '';
  };

  React.useEffect(() => {
    setIsSameEmail(voucherData.otherBusinessEmail?.localeCompare(voucherData.businessEmail) === 0);
  }, [voucherData]);

  React.useEffect(() => {
    if (isEditMode) {
      setVoucherData((prevState) => ({
        ...prevState,
        businessEmail: voucherData.addressee?.voucher,
        otherBusinessEmail: voucherData.addressee?.password,
      }));
    }
  }, [voucherData.addressee]);

  return (
    <Container container>
      <Grid item xs={12} className="no-spacing">
        <Typography variant="titleS">Add delivery information</Typography>
        <Typography variant="bodyM">Once order is confirmed, you will receive 2 emails:</Typography>
        <div>
          <ul className="list-style marign-left-16">
            <li>
              <Typography variant="bodyMBold">
                Email 1: Password-protected file containing all E-Gift Vouchers
              </Typography>
            </li>
            <li>
              <Typography variant="bodyMBold">
                Email 2: Your password to access the file in Email 1
              </Typography>
            </li>
          </ul>
        </div>
      </Grid>
      <Grid item xs={12} className="margin-y-24 no-spacing">
        <Typography variant="bodyM">Please confirm your email below:</Typography>
      </Grid>

      <Grid item xs={12} className="no-spacing">
        <Input
          className="input-full-width"
          required
          label="Send order to"
          name="email"
          data-testid="email-send-to"
          error={isError}
          value={voucherData.businessEmail ? voucherData.businessEmail : ''}
          onBlur={(event) => handleOnBlur(event.target.name, event.target.value)}
          onChange={(e) => {
            setVoucherData((prevState) => ({
              ...prevState,
              businessEmail: e.target?.value,
            }));
          }}
          helpText={getHelperTextEmail()}
          placeholder="name@email.com"
        />
      </Grid>
      <Grid item xs={12} className="margin-y-24 no-margin-bottom no-spacing">
        <StyledAcknowledge>
          <Checkbox data-testid="checkbox" onChange={(e) => setIsCheck(e?.target?.checked)} />
          <StyledTypography>
            I want to send my password to a different email address
          </StyledTypography>
        </StyledAcknowledge>
        {isCheck && (
          <div className="margin-y-24 no-margin-bottom">
            <div>
              <Input
                label="Send password to"
                name="resend-email"
                data-testid="email-resend-to"
                onBlur={(event) => handleOnBlur(event.target.name, event.target.value)}
                error={isErrorEmail || isSameEmail}
                value={voucherData.otherBusinessEmail ? voucherData.otherBusinessEmail : ''}
                onChange={(e) => {
                  setVoucherData((prevState) => ({
                    ...prevState,
                    otherBusinessEmail: e.target?.value,
                  }));
                }}
                className="input-full-width"
                required
                placeholder="name@email.com"
                helpText={helpOtherEmailText()}
              />
            </div>
          </div>
        )}
      </Grid>
    </Container>
  );
};

export default DeliveryInformation;
